import { IOfferState } from '../../../../types/reducers/offer';
import { getPhone } from '../../../../utils/getPhone';

export const getIsCalltrackingPhoneChanged = (offer: IOfferState): boolean => {
  const { calltrackingPhone, phones } = offer;

  if (!calltrackingPhone) {
    return false;
  }

  if (!Array.isArray(phones) || !phones.length) {
    return true;
  }

  return phones.every(phone => {
    return getPhone(phone) !== calltrackingPhone;
  });
};
